// extracted by mini-css-extract-plugin
module.exports = {"logo":"Bar_logo__3H3_o"};